import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29381163"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-good-item" }
const _hoisted_2 = {
  class: "shop-title",
  style: {"border-top":"1px solid #fff"}
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"max-width":"284px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/question_icon.png",
  class: "question-icon cursor-pt",
  style: {"width":"16px"}
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "text"
}
const _hoisted_7 = {
  key: 2,
  class: "text"
}
const _hoisted_8 = { class: "shop-goods" }
const _hoisted_9 = { class: "shop-goods-content" }
const _hoisted_10 = { class: "btn-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/main.png",
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/del.png",
  alt: ""
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "shop-good-item-tip"
}
const _hoisted_14 = {
  key: 1,
  class: "shop-good-item-black"
}
const _hoisted_15 = { class: "shop-good-item-black-text" }
const _hoisted_16 = { class: "shop-title shop-sku-title" }

import { arr2map } from '@/plugins/utils'
import { t } from '@/plugins/i18n'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import LogoIcon from '@/components/common/LogoIcon.vue'
import SkuItem from './SkuItem.vue'
import bus from '@/util/useBus'
import NoGoods from '../NoGoods.vue'
import confirmDialog from '@/components/common/ConfirmDialog'
import Image from '@/components/common/Image.vue'
import AbnormalGoodsTip from './AbnormalGoodsTip.vue'
import { codeName } from '@/components/BlackGoods/data'
import { ElMessage, ElMessageBox } from 'element-plus'
import { isJA } from '@/store'
import { ShopType } from '@/common/const'
import { useStore } from 'vuex'
import { request } from '@/config/request/interceptors'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'index', 'change', 'height', 'add', 'shopDetail'],
  emits: ['open'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()


const scrollRef = ref()
const route = useRoute()
const isTikTokShop = computed(() => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)

const scrollFn = (e: { scrollTop: number }) => {
  bus.emit('createAssociatedScroll', e.scrollTop)
}
bus.on('createAssociatedScroll', (num: number) => {
  scrollRef.value?.setScrollTop(num)
})

const openDrawer = () => {
  emits('open')
}
const delGoods = () => {
  confirmDialog({
    title: t('是否确认删除2'),
    text: t('删除后将自动解绑该商品下已绑定的SKU'),
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    props.change({
      productIndex: props.index,
      isDelete: true
    })
  })
}

const setMainGood = () => {
  if (props.index > 29) return
  // if (props.product?.blackTag === 1) {
  //   ElMessage.warning(t('黑名单商品不允许关联商品'))
  //   return
  // }
  confirmDialog({
    title: t('提示3'),
    text: t('是否设为主商品'),
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    props.change({
      productIndex: props.index,
      setMain: true
    })
  })
}
const errorText = computed(() => {
  return props.product?.blackTag === 1 && codeName[props.product?.blackReasonCode]?.strict
})
const jumpDetail = () => {
  if (props.product.productType !== 1) return
  window.open('/goods/' + props.product.productCode, '_blank')
}
const addGoods = async (productType:number) => {
  store.commit('status/loading', true)
  bus.emit('changeBindLoading', true)
  request.apis.thirdShopItem.addJpSpu({ shopItemId: String(route.query.shopItemId ?? '') as any, productType }).then(res => {
    if (res.success) {
      if (productType === 3) {
        // 如果是组合商品需要提示
        bus.emit('changeBindLoading', false)
        ElMessageBox.confirm('子商品が未登録のため、セット商品の紐付けはまだ有効になっていません。「日本商品管理」ー「商品マスタ」から子商品を追加してください。', t('提示'), {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning'
        }).finally(() => {
          store.commit('status/loading', false)
          props.add({}, false, true)
        })
        return
      }
      setTimeout(() => {
        store.commit('status/loading', false)
        props.add({
        }, false, true)
      }, 5000)
      return
    }
    store.commit('status/loading', false)
    if (res.code === '40000308') {
      ElMessageBox.confirm(t('该商品已经新增成功，无法二次新增，请选择商品进行关联'), t('提示'), {
        confirmButtonText: t('确定'),
        cancelButtonText: t('取消'),
        type: 'warning'
      })
    }
  }).catch(() => {
    store.commit('status/loading', false)
  }).finally(() => {
    bus.emit('changeBindLoading', false)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.product?.productCode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["logo", __props.index === 0 ? '' : 'second'])
            }, _toDisplayString(__props.index === 0 ? _unref(t)('主2') : _unref(t)('次')), 3),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('商品')), 1),
            (__props.index === 0 && !_unref(isTikTokShop))
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('当所有供货商品库存不足，将会采购主商品')), 1)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.index === 0 && _unref(isJA)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('第{num}顺位商品', { num: __props.index + 1 })), 1))
              : _createCommentVNode("", true),
            (__props.index > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('第{num}顺位商品', { num: __props.index + 1 })), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (__props.product?.productCode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "goods-img",
              onClick: jumpDetail
            }, [
              _createVNode(Image, {
                src: __props.product.productMainImg,
                class: "goods-img"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "goods-name line--2",
                onClick: jumpDetail
              }, [
                _createVNode(LogoIcon, {
                  underline: __props.product.channel === 5,
                  type: __props.product.platformType,
                  class: "logo-icon",
                  country: __props.product.country
                }, null, 8, ["underline", "type", "country"]),
                _createTextVNode(_toDisplayString(__props.product.productTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (__props.index > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["btn", { disabled: props.index > 29 }]),
                      onClick: setMainGood
                    }, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('设为主商品')), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "btn",
                  onClick: delGoods
                }, [
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('删除')), 1)
                ])
              ])
            ]),
            (__props.product?.productType === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(AbnormalGoodsTip, {
                    productCode: __props.product?.productCode,
                    product: __props.product
                  }, null, 8, ["productCode", "product"])
                ]))
              : _createCommentVNode("", true),
            (_unref(errorText))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(errorText)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", null, _toDisplayString(__props.product.productTitle !== 'test' ? _unref(t)('规格') : _unref(t)('SKU编码')), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("div", {
      class: "shop-sku",
      key: __props.height
    }, [
      (__props.product?.productCode)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, {
            key: 0,
            class: "sku-scroll",
            onScroll: scrollFn,
            ref: (_value, _refs) => {
              _refs['scrollRef'] = _value
              scrollRef.value = _value
            },
            style: _normalizeStyle({ height: __props.height + 'px' })
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.shopSkuList, (i, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "sku-item flex-center",
                  key: key
                }, [
                  _createVNode(SkuItem, {
                    product: __props.product,
                    activeItem: i.activeProduct,
                    shopItemSkuId: i.shopItemSkuId,
                    productIndex: __props.index,
                    shopIndex: key,
                    change: __props.change,
                    skuMapping: _unref(arr2map)(
              __props.product?.skuList ?? [],
              (v) => v.productProperties
            )
                  }, null, 8, ["product", "activeItem", "shopItemSkuId", "productIndex", "shopIndex", "change", "skuMapping"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"]))
        : (_openBlock(), _createBlock(NoGoods, {
            key: 1,
            type: "chooseProduct",
            onChange: openDrawer,
            onAddGoods: addGoods,
            shopDetail: __props.shopDetail
          }, null, 8, ["shopDetail"]))
    ]))
  ]))
}
}

})